const lazyLoadHandler = () => {
  let lazyloadThrottleTimeout;
  const images = document.querySelectorAll('.lazy');

  if (lazyloadThrottleTimeout) {
    clearTimeout(lazyloadThrottleTimeout);
  }

  lazyloadThrottleTimeout = setTimeout(() => {
    const scrollTop = window.pageYOffset;
    Array.prototype.forEach.call(images, (img) => {
      if (img.offsetTop < (window.innerHeight + scrollTop)) {
        if (img.dataset.src) {
          img.src = img.dataset.src;
        } else {
          const classNames = img.parentNode.classList;
          if (classNames.toString().indexOf('object-fit') === -1) {
            img.src = img.getAttribute('data-src-ie11');
          }
        }
        img.classList.remove('lazy');
        img.classList.add('image-loaded');
      }
    });

    if (images.length === 0) {
      document.removeEventListener('scroll', lazyLoadHandler);
      window.removeEventListener('resize', lazyLoadHandler);
      window.removeEventListener('orientationChange', lazyLoadHandler);
    }
  }, 20);
};

const lazyload = () => {
  if ('IntersectionObserver' in window) {
    const images = document.querySelectorAll('.lazy');

    const options = {
      rootMargin: '100px',
      threshold: [0],
    };

    const imageObserver = new IntersectionObserver((entries) => {
      Array.prototype.forEach.call(entries, (entry) => {
        if (entry.isIntersecting) {
          const image = entry.target;
          let srcset = image.dataset.src;
          if (!srcset) {
            srcset = image.getAttribute('data-srcset');
          }
          if (srcset !== null) {
            image.srcset = srcset;
            image.classList.remove('lazy');
            image.classList.add('image-loaded');
            imageObserver.unobserve(image);
          }
        }
      });
    }, options);

    images.forEach((image) => {
      imageObserver.observe(image);
    });
  } else {
    lazyLoadHandler();
    document.addEventListener('scroll', lazyLoadHandler);
    window.addEventListener('resize', lazyLoadHandler);
    window.addEventListener('orientationChange', lazyLoadHandler);
  }
};

export default lazyload;
